"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderClient = void 0;
const api_1 = require("../core/api");
/**
 * Client that contains order related operations
 */
class OrderClient {
    constructor(config) {
        this.config = config;
        this.api = new api_1.ApiService(config);
    }
    /**
     * Create/Open new order for specified user (Order will be created based on the user's open cart)
     * @param payload
     */
    createOrder(payload) {
        const { api } = this;
        return api.post(["orders"], payload);
    }
    /**
     * Updates new order for specified user (Order will be created based on the user's open cart)
     * @param id
     * @param payload
     */
    updateOrder(id, payload) {
        const { api } = this;
        return api.put(["orders", id], payload);
    }
    /**
     * Cancel the order for specified user
     * @param id
     */
    cancelOrder(id) {
        const { api } = this;
        return api.delete(["orders", id]);
    }
    /**
     * Fetch the order of the specified user
     * @param id
     */
    getOrderByIdOrKey(id) {
        const { api } = this;
        return api.get(["orders", id]);
    }
    /**
     * Fetch the orders by query
     * @param query
     */
    findOrders(query) {
        const { api } = this;
        return api.get(["orders"], query);
    }
    /**
     * Cancel the order for specified user
     * @param id Order unique identifier
     * @param payload Payment payload
     */
    pay(id, payload) {
        const { api } = this;
        return api.put(["orders", id, "payment"], payload);
    }
}
exports.OrderClient = OrderClient;
//# sourceMappingURL=order.client.js.map